import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, HomeIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CourseSidebar from '../components/course/CourseSidebar';
import VideoPlayer from '../components/course/VideoPlayer';
import CourseContentTabs from '../components/course/CourseContentTabs';
const CourseDetailPage = () => {
  const navigate = useNavigate();
  const [activeModule, setActiveModule] = useState(3);
  const [activeLesson, setActiveLesson] = useState(1);
  const [activeTab, setActiveTab] = useState('descrizione');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleBack = () => {
    navigate('/');
  };
  return <div className="flex h-screen bg-gray-100" data-id="element-2273">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2274">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2275"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black overflow-hidden" data-id="element-2276">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2277">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2278">
              <span className="sr-only" data-id="element-2279">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2280" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2281">
            <Sidebar activePage="formazione" data-id="element-2282" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2283">
        <Sidebar activePage="formazione" data-id="element-2284" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2285">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2286" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-2287">
          <div className="max-w-6xl mx-auto pt-4 md:pt-6" data-id="element-2288">
            {/* Course title and info */}
            <div className="mb-6" data-id="element-2289">
              <h1 className="text-2xl font-semibold text-gray-800" data-id="element-2290">
                Innovazione Sostenibile
              </h1>
              <p className="text-sm text-gray-500" data-id="element-2291">
                Corso completo • 8 moduli • 28 lezioni
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2292">
              {/* Course Sidebar as a widget */}
              <div className="lg:col-span-1" data-id="element-2293">
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-2294">
                  <div className="p-4 border-b border-gray-200" data-id="element-2295">
                    <h2 className="text-base font-semibold text-gray-800" data-id="element-2296">
                      Contenuti del corso
                    </h2>
                  </div>
                  <CourseSidebar activeModule={activeModule} activeLesson={activeLesson} onModuleChange={setActiveModule} onLessonChange={setActiveLesson} data-id="element-2297" />
                </div>
              </div>
              {/* Main Content */}
              <div className="lg:col-span-2" data-id="element-2298">
                <VideoPlayer module={activeModule} lesson={activeLesson} data-id="element-2299" />
                <CourseContentTabs activeTab={activeTab} onTabChange={setActiveTab} module={activeModule} lesson={activeLesson} data-id="element-2300" />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default CourseDetailPage;